import path from 'utils/path';

export const routerPath = {
  root: '/licensed-providers',
  link: '/general/licensed-providers',
  go_classes: (providerId) => path(providerId, `/classes`),
};

export const getColumns = ({ goClasses, editItem, deleteItem }) => [
  { id: 'name', type: 'text', label: 'Name', align: 'left', width: 200 },
  {
    id: 'description',
    label: 'Description',
    align: 'left',
    disableSort: true,
  },
  {
    id: 'classes',
    label: 'Classes',
    action: goClasses,
    icon: 'mdi:dumbbell',
    align: 'left',
    width: 100,
    disableSort: true,
  },
  {
    id: 'more-menu',
    type: 'menu',
    items: [
      { id: 2, name: 'Edit', action: editItem, icon: 'eva:edit-fill' },
      {
        id: 1,
        name: 'Delete',
        action: deleteItem,
        icon: 'eva:trash-2-outline',
        sx: { color: 'error.main' },
      },
    ],
    disableSort: true,
  },
];

export const getFilters = ({ searchByName }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Search by name...',
    action: searchByName.change,
  },
];
